import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import { Typography, Input, Button, Dropdown, Menu, Icon, message, Tabs, Badge } from "antd";
import { ContextAPI } from "../../../ContextAPI";
import { platformApi } from '../../../api';
import { io } from "socket.io-client";
import { ENDPOINT } from "../../../constants";

import InvoiceTable from './InvoiceTable';
import PymidolSyncModal from '../../PymidolSyncModal';

const { Item } = Menu;
const { Search } = Input;
const { Title } = Typography;

const PurchaseSparesInvoice = () => {

  const history = useHistory();
  const { loginCredintials } = useContext(ContextAPI);
  const [dataSource, setData] = useState([]);

  const [editable, setEditable] = useState(false);
  const [createAccess, setCreateAccess] = useState(false);
  const [modifyAccess, setModifyAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);
  const [editableData, setEditableData] = useState({})
  const [redirect, setRedirect] = useState(false);
  const [selected, setSelected] = useState();
  const [spinning, setSpinning] = useState(false);

  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [search, setSearch] = useState('');
  const [gst, setGst] = useState();
  const [syncModalVisible, setSyncModalVisible] = useState(false);
  const [pendingCount, setPendingCount] = useState(0);

  const fetchPendingCount = () => {
    platformApi
      .get("/api/pymidol/pending-count?module=spare_purchase")
      .then((res) => {
        if (res?.data?.code === 200) {
          const pCount = res.data.response?.pendingCount || 0;
          setPendingCount(pCount);
        }
      })
      .catch((err) => {
        console.error("Error fetching pending spare count:", err);
      });
  };

  useEffect(() => {
    fetchPendingCount();

    const socket = io(ENDPOINT, {
      transports: ["websocket"],
      auth: { token: localStorage.getItem("token") },
    });

    socket.on("pymidol_pending_count_updated", (data) => {
      if (data && data.module === "spare_purchase") {
        setPendingCount(data.count);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (loginCredintials && loginCredintials.branch && loginCredintials.branch.length > 0) {
      setGst(loginCredintials.branch[0].gst);
    }
    if (loginCredintials && loginCredintials.roleAccess) {
      loginCredintials.roleAccess.forEach((each) => {
        if (each.subModule === "purchase_spares_invoice" && each.access) {
          if (each.access.create) {
            setCreateAccess(true);
          }
          if (each.access.update) {
            setModifyAccess(true);
          }
          if (each.access.delete) {
            setDeleteAccess(true);
          }
        }
      });
    }
  }, [loginCredintials]);

  useEffect(() => { 

    setPageData(search);
  }, [page, limit, search]);

  const getMenu = () => {
    let size = count / 10 + (count % 10) ? 1 : 0;
    const menus = [];
    menus.push(10);
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item onClick={() => { setLimit(menu), setPage(1) }} key={menu}>
        {menu}
      </Item>
    ));
  };
  const menu = <Menu>{getMenu()}</Menu>;

  const setPageData = (search, val) => {
    setSpinning(true)
    platformApi
      .post("/api/purchaseSpareInvoice/get", {
        page: val ? val : page,
        size: limit,
        searchString: search,
      })
      .then((result) => {
        setSpinning(false);
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            setData(response.data.purchaseSpareInvoice);
            setCount(response.data.count);
          } else {
            message.error("Unable to fetch Spare Purchase Invoice", 2);
          }
        } else {
          message.error("Unable to fetch Spare Purchase Invoice", 2);
        }
      })
      .catch((error) => {
        console.error("Error on Vehicle Spare Purchase Invoice : ", error);
        message.error("Unable to fetch Spare Purchase Invoice", 2);
      });
  };

  const getPSI = () => {
    setSpinning(true)
    platformApi.get("/api/purchaseSpareInvoice").then((result) => {
      setSpinning(false)
      let { data } = result;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          setData(response.data.purchaseshareInvoice);
          setCount(response.data.count);
        } else {
          message.error('Unable to fetch vehicles', 2);
        }
      } else {
        message.error('Unable to fetch vehicles', 2);
      }
    })
      .catch((err) => {
        setSpinning(false)
        console.error("PSI Fetch Error: ", err);
        message.error("Couldn't Fetch PSI");
      });
  }


  const deleteData = (id) => {
    setSpinning(true)
    let temp = page != 1 && Tasks.length === 1;
    // if (page != 1 && Tasks.length === 1) {
    //   setPage(1)
    // }
    platformApi.delete("/api/purchaseSpareInvoice/" + id).then(result => {
      let { data } = result;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          message.success("PSI Deleted Successfully")
          if (temp) {
            setPage(1)
            setPageData(null, 1)
            // getPSI()
          }
          else {
            setPageData()
            // getPSI()
          }
        }
        else {
          setSpinning(false)
          message.error("Couldn't Remove PSI");
        }
      }
      else {
        setSpinning(false)
        message.error("Couldn't Remove PSI");
      }
    }).catch((err) => {
      setSpinning(false)
      console.error("PSI Delete Error: ", err);
      message.error("Unable to Delete PSI");
    });
  }

  return (
    <>
      <div className="accessories-head">
        <Title style={{ width: "30%" }} level={4}>
          Spare Purchase Invoice [{count}]
                  <span style={{ marginLeft: "1rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit} &nbsp;
                    <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title> 
        <Search
          style={{ width: "25%" }}
          placeholder="Search Spare Purchase Invoice"
          onSearch={(event) => {
            setPage(1)
            setSearch(event);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearch(null)
              setPage(1)
            }
          }}
        />
        <Badge count={pendingCount} overflowCount={99} style={{ backgroundColor: "#ff4d4f" }}>
          <Button
            onClick={() => setSyncModalVisible(true)}
            style={{ margin: "0 1%" }}
            type="primary"
            disabled={!createAccess}
          >
            <Icon type="download" />&nbsp;Get Pending Spare Invoice
          </Button>
        </Badge>
        <Button
          onClick={() => {
            history.push({
              pathname: '/autoadmin/purchase_spares_invoice/:id',
              state: {
                gst: gst
              }
            })
            // history.push('/autoadmin/purchase_spares_invoice/:id');
          }}
          style={{ margin: "0 1%", width: "22%" }}
          type="primary"
          disabled={!createAccess}
        >
          Add Spare Purchase Invoice
        </Button>
      </div>
      <InvoiceTable
        gst={gst}
        dataSource={dataSource}
        spinner={spinning}
        deleteData={deleteData}
        setEditableData={setEditableData}
        setEditable={setEditable}
        modify={modifyAccess}
        deleteAccess={deleteAccess}
        redirectPage={(id, editable) => {
          setSelected(id);
          setRedirect(true); 
          setEditable(editable);
        }}
        pagination={{
          onChange: (page) => {
            setPage(page);
          },
          pageSize: limit,
          defaultCurrent: 1,
          current: page,
          total: count,
          showQuickJumper: true,
        }}
      />
      <PymidolSyncModal
        visible={syncModalVisible}
        onClose={() => setSyncModalVisible(false)}
        moduleType="spare_purchase"
        onSuccess={() => setPageData(search)}
      />
    </>
  )
}

export default PurchaseSparesInvoice